<app-broadcast-overlay></app-broadcast-overlay>
<app-header></app-header>
<app-sidebar></app-sidebar>
<app-right-sidebar></app-right-sidebar>
<div [dir]="direction">

  <router-outlet></router-outlet>
</div>
